/**
 * @generated SignedSource<<26841fcc1b4823af282f744699a400ea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedContactDealerWrapper_user$data = {
  readonly serviceId: string | null;
  readonly " $fragmentType": "SharedContactDealerWrapper_user";
};
export type SharedContactDealerWrapper_user$key = {
  readonly " $data"?: SharedContactDealerWrapper_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedContactDealerWrapper_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedContactDealerWrapper_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "b3d1b9e8a5b4eba2da4ab77fa3d249e8";

export default node;
